export const OmniCall = () => {
    return (
        <svg
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ padding: '0 3px' }}
        >
            <path
                d="M2.6331 0.0694226C3.37133 -0.1531 4.15728 0.174176 4.52432 0.838508L4.58465 0.959198L5.12221 2.15497C5.45751 2.90085 5.31093 3.76974 4.76273 4.36343L4.65526 4.47142L3.80734 5.2621C3.65473 5.40642 3.76929 5.96622 4.32203 6.9236C4.81931 7.78491 5.22379 8.18763 5.42289 8.20966L5.45779 8.20935L5.50086 8.20092L7.16745 7.69139C7.62803 7.55057 8.12419 7.69474 8.43792 8.05055L8.51242 8.14386L9.61492 9.67184C10.0633 10.2933 10.0138 11.1368 9.51355 11.7007L9.41448 11.803L8.97336 12.2208C8.16566 12.9857 6.9862 13.2096 5.95442 12.7938C4.38168 12.1601 2.95306 10.7114 1.65513 8.46334C0.354466 6.21052 -0.185347 4.24541 0.056 2.56418C0.205366 1.52373 0.915035 0.655249 1.8939 0.297227L2.05065 0.244988L2.6331 0.0694226Z"
                fill="#336DC4"
            />
        </svg>
    );
};
